module.exports = __webpack_public_path__ + "static/media/zhongniuhushan_web.97e8f190.webp";